import React from 'react';
import { string, node, bool } from 'prop-types';

const Label = (props) => {
  return (
    <label className={props.className} htmlFor={props.htmlFor}>
      {props.label}
      {props.children}
      {props.required && <span className="c-forms__label__required">*</span>}
    </label>
  );
};

export const propTypes = {
  label: node,
  children: node,
  required: bool,
  className: string,
  htmlFor: string,
};

Label.propTypes = propTypes;

export default Label;
